import { useSelector } from 'react-redux';
import { getReplacedString } from '../../../../helpers/getReplacedString';
import { useEffect, useState } from 'react';

const filterCb =
  ({ searchValue }) =>
  (item) => {
    const search = getReplacedString(searchValue);

    const number = getReplacedString(item.transport?.number);
    const brand = getReplacedString(item.transport?.brand);

    return number.includes(search) || brand.includes(search);
  };

const createSelector = (mode) => (state) =>
  state.permitsFilterStore.searchValue[mode];

const useFilteredBySearchDataTransportPermits = ({ data = [], mode }) => {
  const value = useSelector(createSelector(mode));

  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(() => {
    const trimVal = value?.trim();
    return trimVal ? data?.filter(filterCb({ searchValue: trimVal })) : data;
  });

  useEffect(() => {
    const trimVal = value?.trim();

    let timeoutId;

    if (trimVal) {
      setLoading(true);
      timeoutId = setTimeout(() => {
        const newData = data?.filter(filterCb({ searchValue: trimVal }));
        setFilteredData(newData);
        setLoading(false);
      }, 700);
    } else {
      setLoading(false);
      setFilteredData(data);
    }

    return () => clearTimeout(timeoutId);
  }, [value, JSON.stringify(data)]);

  return [loading, filteredData];
};

export default useFilteredBySearchDataTransportPermits;
